// extracted by mini-css-extract-plugin
module.exports = {"ascending":"common-SortSelect__ascending--2GC_4"};